import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取生产订单信息*/
export function GetCheckbill(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/checkbill/",
        params:data
    })
}

/*获取生产订单供应商信息*/
export function SupplierInfo(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/optionssupplier/",
        params:data
    })
}

/*勾选订单发货*/
export function Checkbill(data = {}){
return instance.request({
        method: "post",
        url: "billingmanage/checkbillHandle/",
        data:data,
        timeout:360000
    })
}
